<template>
  <div class="afdc-list-results">
    <template v-if="!$store.getters.getLoadingNearestStations">
      <template v-if="$store.getters.getNearestError">
        <p class="afdc-alert afdc-alert-warning"><em>{{ $store.getters.getNearestError }}</em></p>
      </template>

      <template v-else>
        <template v-if="nearestStations.length > 0">
          <div v-for="(station, index) in nearestStations" v-bind:key="station.id">
            <find-result-station mode="nearest" v-bind:station="station" v-bind:index="index"/>
          </div>

          <router-link v-if="nearestStationsTotal >= (currentPage * 10)" v-bind:to="nextPageUrl" class="afdc-btn afdc-btn-light afdc-btn-sm afdc-float-right" @click.native="scrollResults">{{ $t('Next') }}</router-link>
          <router-link v-if="currentPage > 1" v-bind:to="prevPageUrl" class="afdc-btn afdc-btn-light afdc-btn-sm afdc-float-left" @click.native="scrollResults">{{ $t('Prev') }}</router-link>
          <div class="afdc-page-count"><small>{{ $t('Page') }} {{ currentPage }}</small></div>
        </template>

        <template v-else>
          <p class="afdc-alert afdc-alert-info"><em>{{ $t('There are no stations that match your filters.') }}</em></p>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import FindResultStation from '@/components/FindResultStation.vue';

export default {
  name: 'MapNearest',
  props: ['map'],

  components: {
    FindResultStation,
  },

  computed: {
    nearestStations() {
      return this.$store.getters.nearestStations;
    },

    nearestStationsTotal() {
      return this.$store.getters.nearestStationsTotal;
    },

    currentPage() {
      return this.$store.getters.getFilterValueWithDefault('page');
    },

    nextPageUrl() {
      return {
        name: this.$store.getters.getNavActiveFilterRouteName,
        query: {
          ...this.$store.getters.getFilters,
          page: (this.currentPage + 1),
        },
      };
    },

    prevPageUrl() {
      return {
        name: this.$store.getters.getNavActiveFilterRouteName,
        query: {
          ...this.$store.getters.getFilters,
          page: (this.currentPage - 1),
        },
      };
    },
  },

  watch: {
    '$store.getters.getFiltersFindNearest': {
      immediate: true,
      handler: 'fetchData',
    },

    currentPage: 'fetchData',
  },

  methods: {
    fetchData() {
      if (this.$store.getters.isNavActiveFindModeNearest) {
        this.$store.dispatch('fetchNearestStations', this.$store.getters.getFiltersWithDefaults);
      }
    },

    scrollResults() {
      document.querySelector('.afdc-list-results').scrollTop = 0;
    },
  },
};
</script>

<style lang="scss">
</style>
